var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, createContext } from 'react';
export var AppContext = createContext({ darkMode: false });
var AppContextProvider = function (_b) {
    var children = _b.children;
    var _j = useState({
        darkMode: false,
    }), value = _j[0], setValue = _j[1];
    var init = function () {
        var contextValue = {
            darkMode: false
        };
        setValue(contextValue);
    };
    React.useEffect(function () {
        init();
    }, []);
    return (_jsx(AppContext.Provider, __assign({ value: value }, { children: value ? children : null })));
};
export default AppContextProvider;
